<template>
  <div class="list">
    <div class="search-result-top-txt">
      <span>‘<strong>{{ searchKeyword }}</strong>’ 검색결과가 없어요.</span>
      <span>비슷한 작품을 추천해 드려요.</span>
    </div>
    <cellList
      v-if="recommendCellList && recommendCellList.length"
      :cell-list="recommendCellList"
      :thumbnail-info="thumbnailInfo"
      :container-class-name="getCellListContainerClassName(thumbnailInfo)"
      @cell-click-log="sendCellClickLog"
    />
  </div>
</template>
<script>
import CellList from '@/components/section/template/cell/CellList'
import { sendEventLogSearchRecommendCell } from '@/common/util/log.v2.send'

export default {
  name: 'SearchRecommendCellList.vue',
  components: {
    CellList
  },
  props: {
    searchKeyword: {
      type: String
    },
    recommendCellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  },
  methods: {
    sendCellClickLog ({ cellInfo = {}, index = -1 }) {
      sendEventLogSearchRecommendCell({ cellInfo: cellInfo, index: index })
    },
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type}`
    }
  }
}
</script>
<style scoped>
.search-result-multi-band-container {
  /*overflow-scrolling: touch;*/
  /*-webkit-overflow-scrolling: touch;*/
  /*overflow-y: scroll;*/
  /*overflow-y: scroll;*/
  background-color: #1b1b1b;
}
.search-result-multi-band-container::-webkit-scrollbar{
  display: none;
  background-color: transparent
}
.recent-keyword-empty {
  position: relative;
  width: 100%;
  height: 100%;
}
.attention-mark-area .icon {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 0 auto;
}
.info-text {
  margin-top: 16px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #a5a5a5;
}
.recommend-keyword-list {
  position: relative;
  top: 34px;
  width: 100%;
  padding: 0 5px 0 5px;
  height: 190px;
  text-align: center;
}
.btn-research {
  display: block;
  margin-top: 40px;
  font-size: 12px;
  line-height: 18px;
  color: #a5a5a5;
  text-align: center;
}
.btn-research span,
.btn-research svg{
  vertical-align: middle;
}
.btn-research > svg{
  width: 18px;
  line-height: 18px;
}
.btn-research span + svg{
  margin-left: 4px;
}

/* 검색 결과 > 카테고리 */
.cell-category li{
  width: 160px;
  height: 80px;
  background-color: #252525;
}
.cell-category a{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;
}
.cell-category a > span + strong{
  margin-top: 2px;
}
.cell-category a > span{
  font-size: 12px;
  line-height: 14px;
  color: #a5a5a5;
}
.cell-category a > strong{
  font-size: 14px;
  line-height: 20px;
  color: #fff;
}
</style>
